import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="mt-0 border-t border-gray-200 bg-paper-dark px-6 pb-28 pt-16 md:px-10 md:py-16" data-id="element-198" data-mp="32u0lk5cflfhj">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-8 md:flex-row" data-id="element-199" data-mp="32nukakr5twzs">
        <Logo data-id="element-200" data-mp="36pftnw4hjt58" />
        <div className="text-center text-sm font-medium text-text-muted md:text-right" data-id="element-201" data-mp="36oxyz3xh1mzf">
          <p data-id="element-202" data-mp="3ufa4y995p9nd">
            &copy; {new Date().getFullYear()} Author Leverage. All rights
            reserved.
          </p>
          <p className="mt-2 text-seaglass" data-id="element-203" data-mp="38zawx2kd95j">The path after the book.</p>
        </div>
      </div>
    </footer>;
}